import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";

const importSubModules = () => {
  const modelList = require.context("./modules", true, /\.js$/);
  let subModels = {};
  modelList.keys().forEach((k) => {
    let key = k.match(/^\.\/(.*)\.js$/)[1];
    subModels[key] = modelList(k).default;
  });
  return subModels;
};

let subModules = importSubModules();
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    ...subModules,
  },
  getters,
});

export default store;
